/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель для событий вк
   */
  app.VkEvents = app.Model.extend({
    additionalOptions: ['wish', 'collection', 'cart', 'currency', 'jsView', 'recommendationModel'],
    viewedItems: [],
    /**
     * Массив jsView, при которых не надо отправлять событие app.VK_TARGETING_EVENT_TYPES.other
     */
    JS_VIEWS_WITHOUT_OTHER_EVENT: ['reactive-checkout', 'cart', 'category', 'search'],
    ITEMS_LENGTH_FOR_PUSH: 10,
    MAX_RECOMMENDED_STRING: 20,
    /**
     * Объект связывающий jsView и тип отсылаемого события
     * для инициализации отслеживания просмотра товаров,
     * ключ - jsView, значение - тип события
     * @type {Object}
     */
    TRACK_ITEMS_VIEWS_WITH_EVENT_TYPE: {
      category: app.VK_TARGETING_EVENT_TYPES.category,
      search: app.VK_TARGETING_EVENT_TYPES.search,
    },

    /** @inheritDoc */
    run: function () {
      Backbone.on('vk-product-event', this.pushProductEvent, this);
      if (this.collection) {
        if (Object.keys(this.TRACK_ITEMS_VIEWS_WITH_EVENT_TYPE).indexOf(this.jsView) !== -1) {
          this.listenTo(this.collection, 'change:is_viewed', this.handleViewItem);
        }
        if (this.collection instanceof app.Search && this.recommendationModel) {
          this.listenToOnce(this.collection, 'sync', this.handleSearchCollectionSync);
        }
        this.listenTo(this.wish, 'update', this.createVkWishEvent);
      }
      if (this.JS_VIEWS_WITHOUT_OTHER_EVENT.indexOf(this.jsView) === -1) {
        this.pushProductEvent(app.VK_TARGETING_EVENT_TYPES.other, {});
      }
      Backbone.on('vk-cart-event', this.createVkCartEvent, this);
    },

    /**
     * Обработка синхронизации поисково коллекции
     * @param {app.Search} collection Поисковая коллекция
     */
    handleSearchCollectionSync: function (collection) {
      if (collection && !collection.length) {
        this.listenToOnce(this.recommendationModel, 'sync', this.handleRecommendationSync);
        this.stopListenTrackItems();
      }
    },

    /**
     * Обработка синхронизации рекомендованных товаров
     * @param {app.PersonalRecommendations} model       Модель рекомендаций
     * @param {Array}                       model.items Массив рекомендованных товаров
     */
    handleRecommendationSync: function (model) {
      var items = model.get('items'),
        itemsIds = items.map(function (item) {
          return item.id;
        }),
        recommendedString = this.getRecommendedString(itemsIds),
        params = {
          search_string: this.collection.query,
          products_recommended_ids: recommendedString,
        };
      this.pushProductEvent(app.VK_TARGETING_EVENT_TYPES.search, params);
    },

    /**
     * Генерирует из массива строку длинной не больше MAX_RECOMMENDED_STRING
     * @param {Array} ids Массив ids вида [12345, 6789, 09876543]
     * @return {string} Строка Вида '12345,6789'
     */
    getRecommendedString: function (ids) {
      var string = '';
      ids.forEach(function (id, index) {
        if ((string + id).length <= this.MAX_RECOMMENDED_STRING) {
          string += id + ',';
        }
        if (index === ids.length - 1) {
          string = string.slice(0, -1);
        }
      }.bind(this));
      return string;
    },
    
    /**
     * Добавляет товар в массив просмотренных товаров
     * Если моделей накапливается кол-вом равным this.ITEMS_LENGTH_FOR_PUSH,
     * отправляет vk событие и отключает слушатель события просмотра товаров
     * @param {app.Model} item Модель товара
     */
    handleViewItem: function (item) {
      this.viewedItems.push(item.toJSON());
      if (this.viewedItems.length === this.ITEMS_LENGTH_FOR_PUSH) {
        this.stopListenTrackItems();
        this.createVkCategoryEvent(this.viewedItems);
      }
    },

    /**
     * Отключает слушатель события просмотра товаров
     */
    stopListenTrackItems: function () {
      this.stopListening(this.collection, 'change:is_viewed', this.handleViewItem);
    },

    /**
     * Формирует событие категории и отправляет его
     * @param {app.Model[]} items Массив моделей товаров
     */
    createVkCategoryEvent: function (items) {
      var eventType = this.TRACK_ITEMS_VIEWS_WITH_EVENT_TYPE[this.jsView],
        params = {};
      params.products = items.map(this.getItemData.bind(this));
      if (this.collection instanceof app.Search) {
        params.search_string = this.collection.query;
      }
      this.pushProductEvent(eventType, params);
    },

    /**
     * Формирует событие добавления/удаления избранного и отправляет его
     * @param {app.wish} wishCollection         Коллекция избранного
     * @param {Object}   data                   Объект с данными
     */
    createVkWishEvent: function (wishCollection, data) {
      var changedWishItems,
        products,
        isAdd = data.add,
        eventType = isAdd 
          ? app.VK_TARGETING_EVENT_TYPES.addWishItem 
          : app.VK_TARGETING_EVENT_TYPES.removeWishItem;
      if (isAdd) {
        changedWishItems = data.changes.added;
      } else {
        changedWishItems = data.changes.removed;
      }
      products = changedWishItems.map(function (wishModel) {
        var collectionModel = this.collection.get(wishModel.get('item_id'));
        if (collectionModel) {
          return this.getItemData(collectionModel.toJSON());
        } else {
          return null;
        }
      }.bind(this))
        .filter(function (item) {
        return !_.isNull(item);
      });
      if (products.length) {
        this.pushProductEvent(eventType, {products: products});
      }
    },

    /**
     * Формирует событие добавления/удаления товара из корзины и отправляет его
     * @param {app.Model}  model  Модель товара
     * @param {boolean}    isAdd  Признак - товар добавлен
     */
    createVkCartEvent: function (model, isAdd) {
      var products,
        eventType = isAdd 
          ? app.VK_TARGETING_EVENT_TYPES.addCartItem
          : app.VK_TARGETING_EVENT_TYPES.removeCartItem,
        currentModel = {
          sid: model.item_sid,
          price: model.price,
          has_discount: model.item instanceof app.Model ? model.item.get('has_discount') : model.has_discount,
          price_max: model.price_max,
        };
      products = [this.getItemData(currentModel)];
      this.pushProductEvent(eventType, {products: products});
    },

    /**
     * Данные товара для vk targeting
     * @param {app.Model} model Модель товара
     * @returns {Object} Объект данных товара
     */
    getItemData: function (model) {
      var result = {
        id: model.sid ? model.sid : model.item_sid,
        price: app.helpers.CurrencyConverter.convertByRate(model.price, this.currency.rate)
      };
      if (Boolean(model.has_discount) && model.price_max) {
        result.price_old = app.helpers.CurrencyConverter.convertByRate(model.price_max, this.currency.rate);
      }
      return result;
    },

    /**
     * Отправка события в хелпер
     * @param {string} eventType Тип
     * @param {Object} params    Параметры
     */
    pushProductEvent: function (eventType, params) {
      app.helpers.vkTargetingHelper.pushProductEvent(eventType, params);
    }
  });
})();

}.call(window));